export default {
  methods: {
    async activate (params, callback) {
      // if (!this.inApp) {
      //   const entersource = 'h5_1aa00_a143_0'
      //   this.openInstallInit(this.$route, {
      //     entersource,
      //     openinstallLink: `${window.speroBridge.baseUrl}mine`
      //   }, false, true)
      //   return
      // }
      try {
        const {data: {code, message, data}} = await this.$rootApi.api(['courseActivate'], {
          data: params
        })
        if (code === 0) {
          callback && callback(params, data)
        } else {
          if (params.classId) {
            callback({type: 'error', message})
            return
          }
          throw message
        }
      } catch (e) {
        this.$toast(e.message || e)
      }
    }
  }
}
